// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'

// Create the Navigation Context
const NavigationContext = React.createContext({
  mobileCollapsed: false,
  toggleMobileCollapse: () => {},
})

export default NavigationContext
